<template>
  <div class="component-upload-image">
    <el-upload
        multiple
        :action="uploadImgUrl"
        list-type="picture-card"
        :on-success="handleUploadSuccess"
        :before-upload="handleBeforeUpload"
        :limit="limit"
        :on-error="handleUploadError"
        :on-exceed="handleExceed"
        ref="imageUpload"
        :on-remove="handleDelete"
        :show-file-list="true"
        :headers="headers"
        :file-list="fileList"
        :on-preview="handlePictureCardPreview"
        :class="{hide: this.fileList.length >= this.limit}"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- 上传提示 -->
<!--    <div class="el-upload__tip" slot="tip" v-if="showTip">-->
<!--      请上传-->
<!--      <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>-->
<!--      <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>-->
<!--      的文件-->
<!--    </div>-->

    <el-dialog
        :visible.sync="dialogVisible"
        title="预览"
        width="800"
        append-to-body
    >
      <img
          :src="dialogImageUrl"
          style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from "@/utils/auth";
// import { listByIds, delOss } from "@/api/system/oss";
import baseUrl from "@/request/config.js"
export default {
  model: { // 关键：启用自定义v-model双向绑定[1,11](@ref)
    prop: "value",
    event: "change"
  },
  props: {
    value: [String, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 1,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 20,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      baseUrl:  baseUrl,
      uploadImgUrl: baseUrl + "/sign/live/doctor/uploadFetchFile", // 上传的图片服务器地址
      headers: {
        // Authorization: "Bearer " + getToken(),
      },
      fileList: []
    };
  },
  watch: {
    value: {
      async handler(val) {
        console.log("子组件监听的值",val)
        // 将父组件传入的value转为标准fileList格式[9](@ref)
        if (!val) this.fileList = [];
        else if (this.limit === 1) {
          this.fileList = [{ url: val }]; // 单文件格式
        } else {
          this.fileList = val.map(url => ({ url })); // 多文件格式
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$message(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
        return false;
      }
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      // this.loading("正在上传图片，请稍候...");
      this.number++;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res)
      console.log(file)
      // if (res.code === 200) {
        console.log("200")


        const newFile = {
          url: res.data.fileUrl
          // url: res
        };

        // 更新文件列表
        if (this.limit === 1) {
          this.fileList = [newFile];
          console.log("fanhui",newFile.url)
          this.$emit("change", newFile.url); // 单文件返回URL字符串
        } else {
          this.fileList = [...this.fileList, newFile];
          const urls = this.fileList.map(file => file.url);
          console.log("fanhui1",urls)
          this.$emit("change", urls); // 多文件返回URL数组
        }


      // }
    },
    // 删除图片
    handleDelete(file) {
      const newList = this.fileList.filter(f => f.uid !== file.uid);
      this.fileList = newList;

      // 更新父组件绑定值
      if (this.limit === 1) {
        this.$emit("change", "");
      } else {
        this.$emit("change", newList.map(f => f.url));
      }
    },
    // 上传失败
    handleUploadError(res) {
      this.$message.msgError("上传图片失败，请重试");
      this.$message.closeLoading();
    },

    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
      separator = separator || ",";
      for (let i in list) {
        if (list[i].ossId) {
          strs += list[i].ossId + separator;
        }
      }
      return strs != "" ? strs.substr(0, strs.length - 1) : "";
    }
  }
};
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}
// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}
</style>

